import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { Footer } from '@/components/layout/footer'
import { Header } from '@/components/layout/header'
import { EmployerPage } from '@/pages/employer-page'
import { NotFoundPage } from '@/pages/not-found-page'
import { PrivacyPolicyPage } from '@/pages/privacy-policy-page'
import { TalentPage } from '@/pages/talent-page'
import { TermsOfUsePage } from '@/pages/terms-of-use-page'

// Same five routes as legacy App.jsx. `/jobs` is NOT here on purpose: it never existed in this
// app — the header's "Jobs" is an external link into the talent app.
export function App() {
  return (
    <BrowserRouter>
      <div className="main-frame">
        <Header />

        <main>
          <Routes>
            <Route path="/" element={<TalentPage />} />
            <Route path="/employers" element={<EmployerPage />} />
            <Route path="/terms-of-use" element={<TermsOfUsePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  )
}
